import type { ReactNode } from 'react'
import Icon from '../Icon'

interface KPIProps {
  label: string
  value: string | number
  icon?: ReactNode
  delta?: number
  sub?: string
  deltaFallback?: string
  tone?: 'dark' | 'accent' | ''
}

const KPI = ({
  label,
  value,
  icon,
  delta,
  sub,
  deltaFallback,
  tone = '',
}: KPIProps) => (
  <div className={`kpi ${tone}`}>
    <div className="kpi-heading">
      {icon && <span className="kpi-icon">{icon}</span>}
      <div className="label">{label}</div>
    </div>
    <div className="v">{value}</div>
    {delta != null ? (
      <div
        className={`delta ${delta > 0 ? 'up' : delta < 0 ? 'dn' : ''}`}
      >
        {delta !== 0 && (
          <Icon name={delta > 0 ? 'arrowUp' : 'arrowDn'} size={12} />
        )}
        {Math.abs(delta)}% {sub}
      </div>
    ) : deltaFallback ? (
      <div className="delta">{deltaFallback}</div>
    ) : null}
  </div>
)

export default KPI
